import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Snackbar,
  Alert,
  AlertProps,
} from "@mui/material";
import ManufacturingMasterTable from "./PackagingMasterTable";
import btnDownloadIcon from ".././../../Assests/download.svg";
import {
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  EditProductTableSuccess,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  MEDIUM_DOWNLOAD_NUT_PACKAGING_MASTER_TABLE_API,
  MEDIUM_VIEW_NUT_PACKAGING_MASTER_TABLE_API,
  NEW_BUILK_EDIT_MEDIUM_NUT_PACKAGING_MASTER_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import * as actions from "../../../Redux/Actions/index";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";

import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function MediumPackagingMaster(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectCapacity, setSelectCapacity] = useState<any>("");
  const [selectCascade, setSelectCascade] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [capacityOptions, setCapacityOptions] = useState<any>([]);
  const [cascadeOptions, setCascadeOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "[cascade]", value: "" },
    { key: "basepack", value: "" },
    { key: "capacity", value: "" },
  ]);

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  /**Redux state */
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  var fact = 0;
  var base = 0;
  var cascade = 0;
  var capacity = 0;
  const handleChangeSelectFactory = (event: any) => {
    setSelectBasepack("");
    setSelectCapacity("");
    setSelectCascade("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setSelectFactory(value);
    filterRequest[0].value = value;
    callTableGridApi();
    fact = 1;
    cascade = 0;
    capacity = 0;
  };

  const handleChangeSelectCascade = (event: any) => {
    fact = 1;
    setSelectBasepack("");
    setSelectCapacity("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setSelectCascade(value);
    filterRequest[1].value = value;
    callTableGridApi();
    cascade = 1;
    base = 0;
    capacity = 0;
  };

  // const handleChangeSelectLine = (event: any) => {
  //   const { target: { value } } = event;
  //   setSelectLine(value);
  //   filterRequest[2].value = value;
  //   callTableGridApi();
  // };

  const handleChangeSelectBasepack = (event: any) => {
    fact = 1;
    const {
      target: { value },
    } = event;
    filterRequest[3].value = "";
    setSelectBasepack(value);
    setSelectCapacity("");
    filterRequest[2].value = value;
    callTableGridApi();
    base = 1;
    capacity = 0;
    cascade = 1;
  };

  const handleChangeSelectCapacity = (event: any) => {
    fact = 1;
    const {
      target: { value },
    } = event;
    setSelectCapacity(value);
    filterRequest[3].value = value;
    callTableGridApi();
    base = 1;
    cascade = 1;
    capacity = 1;
  };

  console.log(capacityOptions, "capiiiiiii");

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        factory_Code: "",
        factory: "",
        format: "",
        cascade: "",
        line: "",
        pack: "",
        basepack_Code: "",
        basepack: "",
        product: "",
        designed_Speed: 0,
        net_Weight: 0,
        capacity: "",
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    //const requestParam =  { "usecaseId": 1, "category_id": 1,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblNutritionManufacturingMaster", "time_period": "string", "filter": filterList};
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: "tblNutritionPackagingMaster_Add_MT",
      time_period: "string",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + MEDIUM_DOWNLOAD_NUT_PACKAGING_MASTER_TABLE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  const callTableGridApi = (resetfilter?: any) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList };
    // const requestParam = { "usecaseId": 1, "category_id": 1,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList }
    //const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblNutritionPackagingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList }
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    //const requestParam =  { "usecaseId": 1, "category_id": 1,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblNutritionManufacturingMaster", "time_period": "string", "filter": filterList};
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: "tblNutritionPackagingMaster_Add_MT",
      time_period: "string",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: resetfilter ? resetfilter : filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + MEDIUM_VIEW_NUT_PACKAGING_MASTER_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "data");
          setIsProcessed(true);
          setRows(response.data);

          if (fact === 0) {
            setFactoryOptions(actions.loadFactoryOptions(response.data));
          }
          if (cascade === 0)
            setCascadeOptions(actions.loadCascadeOptions(response.data));
          if (base === 0)
            setBasepackOptions(actions.loadBasePackOptions(response.data));
          if (capacity === 0)
            setCapacityOptions(loadCapacityOptions(response.data));
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadCapacityOptions = (data: any) => {
    console.log(data, "dateeeeeeeee");
    const capacityPackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = capacityPackOptions.find((obj: any) => {
        return obj.capacity === item.capacity;
      });
      if (filteredItem === undefined || filteredItem == null) {
        capacityPackOptions.push({ id: item.id, capacity: item.capacity });
      }
    });
    //console.log(capacityPackOptions,"cpacityoptions")
    return capacityPackOptions;
    //setTimePeriodOptions(timePeriodPackOptions);
  };

  const getfiltersApi = () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    //const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblNutritionManufacturingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    //const requestParam =  { "usecaseId": 1, "category_id": 1,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblNutritionManufacturingMaster", "time_period": "string", "filter": filterList};
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: "tblNutritionPackagingMaster_Add_MT",
      time_period: "string",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + MEDIUM_VIEW_NUT_PACKAGING_MASTER_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          // setFactoryOptions(response.data.factoryFilter);
          // setBasepackOptions(response.data.basepackFilter);
          // setCapacityOptions(response.data.capacityFilter);
          // setCascadeOptions(response.data.cascade_NoFilter);
          setLineOptions(response.data.lineFilter);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  useEffect(() => {
    if (selectedUsecaseId === 2 && selectedCategoryId === 2) {
      callTableGridApi();
    }
    getfiltersApi();
    console.log(selectedScenarioId, "scenario id");
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
  ]);

  const handleRestoreClicked = (e: any) => {
    setSelectFactory("");
    setSelectBasepack("");
    setSelectCapacity("");
    setSelectCascade("");
    //setSelectLine("");
    setFilterRequest([
      { key: "factory", value: "" },
      { key: "cascade", value: "" },
      { key: "basepack", value: "" },
      { key: "capacity", value: "" },
    ]);
    callTableGridApi([]);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const handleFetchEditData = (val: any) => {
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "factory_Code",
      "factory",
      "format",
      "cascade",
      "line",
      "pack",
      "basepack_Code",
      "basepack",
      "product",
      "designed_Speed",
      "net_Weight",
      "capacity",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        rest.usecaseId = selectedUsecaseId;
        rest.category_Id = selectedCategoryId;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls =
      API_BASE_URL + NEW_BUILK_EDIT_MEDIUM_NUT_PACKAGING_MASTER_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    putRequest(urls, transformedRows, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          //dispatch(enableEditFilter(false, "handlecat"));
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        // dispatch(enableEditFilter(false, "handlecat"));
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose();
    // }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited PackagingMaster table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Shift And Changeover"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Packaging Master</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
                titleAccess="Reset"
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Factory</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFactory}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFactory}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Factory</em>
                  </MenuItem>
                  {factoryOptions?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.factory_Name}>
                        {d.factory_Name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Cascade</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectCascade}
                  placeholder="Select Cascade"
                  onChange={handleChangeSelectCascade}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Cascade</em>
                  </MenuItem>
                  {cascadeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.cascade}>
                        {d.cascade}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Basepack</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectBasepack}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectBasepack}
                  // renderValue={(selectBasepack: any) => selectBasepack}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Basepack</em>
                  </MenuItem>
                  {basepackOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.basepack}>
                        {d.basepack}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {selectedScenarioId > 0 ? (
              <div className="filter-item">
                <FormControl fullWidth className="selectDropdown">
                  {/* <InputLabel>Capacity</InputLabel> */}
                  <Select
                    id="simple-select-4"
                    value={selectCapacity}
                    placeholder="Select Capacity"
                    onChange={handleChangeSelectCapacity}
                    // renderValue={(selectCapacity: any) => selectCapacity}
                    className="select-short-term"
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Capacity</em>
                    </MenuItem>
                    {capacityOptions?.map((d: any) => {
                      return (
                        <MenuItem key={d} value={d.capacity}>
                          {d.capacity}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            ) : (
              ""
            )}
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}
            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>

      <div>
        <ManufacturingMasterTable
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          ref={childRef}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default MediumPackagingMaster;
